const _TokenABI = JSON.parse(
  '[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"potentialContract","type":"address"}],"name":"isContract","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approveMore","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approveLess","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"}],"name":"addForwarding","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"removeForwarding","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"Forwards","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"},{"name":"_data","type":"bytes"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_total_supply","type":"uint256"}],"name":"Deployed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_from","type":"address"},{"indexed":true,"name":"_to","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_owner","type":"address"},{"indexed":true,"name":"_spender","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Approval","type":"event"}]'
);
const _TokenAddress = '0x72a521846d5d92f8d98ad9d0a01917be60803b85';

//Returns an object whose methods correspond to used token methods
function CreateTokenContract(contract_address, _Web3, opts) {
  if (typeof opts !== 'object') {
    if (typeof opts !== 'undefined') {
      throw new Error('Token Contract Options must be undefined or an object');
    } else {
      opts = {};
    }
  }

  if (typeof contract_address == 'undefined' || contract_address === null) {
    contract_address = _TokenAddress;
  } else if (typeof contract_address != 'string') {
    throw new Error('Token Contract Address must be a String');
  } else if (typeof _Web3 != 'object') {
    throw new Error('Web3 Must be defined for Token Contract creation');
  } else {
    const TokenContract = {
      approve: createApprove(contract_address, _Web3, opts),
      transfer: createTransfer(contract_address, _Web3, opts),
      checkAllowance: createCheckAllowance(contract_address, _Web3, opts)
    };
    return TokenContract;
  }
}

function debugOut(debugToConsole, message) {
  if (debugToConsole) {
    console.log(message);
  }
}

function createApprove(token_address, _Web3, opts) {
  if (typeof opts != 'object') {
    opts = {};
  }
  if (typeof token_address != 'string') {
    throw new Error('Token Address must be a string');
  } else if (typeof _Web3 != 'object') {
    throw new Error('Web3 must be an Object');
  } else {
    return token_contract_approve;
  }

  function token_contract_approve(account, amount, callback) {
    var tokenContract = _Web3.eth.contract(_TokenABI).at(token_address);
    var lastCall = false;

    createCheckAllowance(token_address, _Web3, opts)(account, function(
      error,
      result
    ) {
      if (error) {
        callback(error);
      } else if (result > 0 && amount !== 0) {
        //Switch approval back to zero if it is not already
        //For some reason this flow is required to prevent race conditions from bad actors
        //I don't think the reasoning is valid but oh well
        token_contract_approve(account, 0, checkApprovalReset);
      } else {
        callApproval();
      }
    });

    function checkApprovalReset(error, result) {
      if (error) {
        debugOut(opts.debug, 'Token Approval Error: Unable to reset Allowance');
        console.error(error);
        callback(error);
      } else if (!result) {
        callback({error: 'Unable to reset Allowance to 0'});
      } else {
        callApproval();
      }
    }

    function callApproval() {
      tokenContract.approve.call(account, amount, function(error, result) {
        if (error) {
          callback(error);
        } else if (!result) {
          callback({error: 'Unble to Approve Allowance'});
        } else {
          debugOut(opts.debug, 'Sending Allownance Approval Transaction');
          tokenContract.approve.sendTransaction(
            account,
            amount,
            {from: _Web3.eth.accounts[0], gas: 2000000},
            checkApproval
          );
        }
      });
    }
    function checkApproval(error, result) {
      if (!lastCall) {
        //Send transaction fires callback twice
        lastCall = true;
        if (error) {
          callback(error);
        } else if (!result) {
          callback({error: 'Approval Transaction Failed'});
        } else {
          debugOut(opts.debug, 'Approval Transaction: ' + result);
          callback(null, result);
        }
      }
    }
  }
}

function createTransfer(token_address, _Web3, opts) {
  if (typeof opts != 'object') {
    opts = {};
  }
  if (typeof token_address != 'string') {
    throw new Error('Token Address must be a string');
  } else if (typeof _Web3 != 'object') {
    throw new Error('Web3 must be an Object');
  } else {
    return token_contract_transfer;
  }

  async function token_contract_transfer(account, amount, callback) {
    debugOut(opts.debug, 'Transfer Token Requested');
    const tokenContract = _Web3.eth.contract(_TokenABI).at(token_address);
    let lastCall = false;
    if (typeof amount == 'string') {
      let err = false;
      try {
        amount = parseInt(amount);
      } catch (e) {
        console.error(e);
        err = true;
        return callback(e);
      }
      if (!err) {
        callTransfer();
      }
    } else {
      callTransfer();
    }

    function callTransfer() {
      debugOut(
        opts.debug,
        'Checking Transfer: ' + amount.toString() + ' CNG to ' + account
      );
      tokenContract.transfer.call(account, amount, function(error, result) {
        if (error) {
          callback(error);
        } else if (!result) {
          callback({error: 'Unble to Transfer Tokens'});
        } else {
          debugOut(opts.debug, 'Sending Token Transfer Transaction');
          tokenContract.transfer.sendTransaction(
            account,
            amount,
            {from: _Web3.eth.accounts[0], gas: 5000000},
            checkTransaction
          );
        }
      });
    }
    function checkTransaction(error, result) {
      debugOut(opts.debug, 'Checking Transfer TX Result');
      if (!lastCall) {
        lastCall = true;
        if (error) {
          callback(error);
        } else if (!result) {
          callback({error: 'Transfer Transaction Failed'});
        } else {
          debugOut(opts.debug, 'Transfer Transaction: ' + result);
          alert('Transfer Submitted. Tx Hash: ' + result);
          callback(null, result);
        }
      }
    }
  }
}

function createCheckAllowance(token_address, _Web3, opts) {
  if (typeof opts != 'object') {
    opts = {};
  }
  if (typeof token_address != 'string') {
    throw new Error('Token Address must be a string');
  } else if (typeof _Web3 != 'object') {
    throw new Error('Web3 must be an Object');
  } else {
    return token_contract_check_allowance;
  }
  function token_contract_check_allowance(account, callback) {
    const tokenContract = _Web3.eth.contract(_TokenABI).at(token_address);
    debugOut(opts.debug, 'Checking Approval');
    tokenContract.allowance.call(
      _Web3.eth.accounts[0],
      account,
      {
        /*transaction object*/
      },
      'pending',
      function(error, result) {
        if (error) {
          console.error(error);
          callback(error);
        } else {
          callback(null, result);
        }
      }
    );
  }
}

export default CreateTokenContract;
